import { LocationVarKey } from "@swivl-mono/types";

import { TOPIC_VARS_BY_ID } from "../../../Views/Properties/CortexV3/Topics";
import { CortexTopicWorksheet } from "../Components/CortexTopicWorksheet";

export const PAGE_KEYS: LocationVarKey[] = TOPIC_VARS_BY_ID["website"] ?? [];

export default function WebsitePage(): React.ReactElement {
  return (
    <CortexTopicWorksheet
      topicId="website"
      heading="Website"
      description="How the bot builds links into this facility's website and spot pages."
      sectionEditing
    />
  );
}
